<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        <material-card color="blue" flat full-width title="Товары каталога">
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="data"
            :options.sync="options"
            :server-items-length="totalDesserts"
            :loading="loading"
            show-select
          >
            <template #top>
              <v-toolbar flat>
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="searchid"
                      label="Поиск по ID"
                      class="mx-4"
                      @change="$apollo.queries.Offers.refetch()"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="searchart"
                      label="Поиск по артикулу"
                      class="mx-4"
                      @change="$apollo.queries.Offers.refetch()"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="search"
                      label="Поиск по названию"
                      class="mx-4"
                      @change="$apollo.queries.Offers.refetch()"
                    />
                  </v-col>
                  <v-col>
                    <v-select
                      v-model="searchstatus"
                      :items="['', 'active', 'disable']"
                      label="Статус"
                      class="mx-4"
                      @change="$apollo.queries.Offers.refetch()"
                    />
                  </v-col>
                  <v-col>
                    <category-select-filter
                      class="mx-4 pt-1"
                      :default="searchcategory"
                      @selected="selectFilterCategory"
                    />
                  </v-col>
                </v-row>
                <v-spacer />
                <v-btn
                  v-if="selected.length > 0"
                  color="red"
                  dark
                  class="mb-2 mr-2"
                  @click="deleteOffers"
                >
                  Удалить
                </v-btn>
                <v-dialog v-model="dialog">
                  <template #activator="{ on, attrs }">
                    <v-btn
                      color="blue"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Новая запись
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span
                        v-if="newItem"
                        class="headline"
                      >Добавление Товара</span>
                      <span
                        v-if="!newItem"
                        class="headline"
                      >Редактирование Товара</span>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col sm="3">
                          <v-card>
                            <v-card-title>Основная категории</v-card-title>
                            <v-card-text>
                              <category-select-main
                                :open-dialog="dialog"
                                :default="editedItem.category_id"
                                @selected="addCategoryId"
                              />
                            </v-card-text>
                          </v-card>
                          <v-card>
                            <v-card-title>Дополнительные категории</v-card-title>
                            <v-card-text>
                              <category-select
                                :open-dialog="dialog"
                                :default="editedItem.category"
                                @selected="addCategory"
                              />
                            </v-card-text>
                          </v-card>
                          <v-card>
                            <v-card-title>Теги</v-card-title>
                            <v-card-text>
                              <category-select
                                :open-dialog="dialog"
                                :default="editedItem.tags"
                                labelText="Теги"
                                @selected="addTags"
                              />
                            </v-card-text>
                          </v-card>
                          <v-card>
                            <v-card-title>Сопутствующие товары</v-card-title>
                            <v-card-text>
                              <relations
                                :open-dialog="dialog"
                                :default="editedItem.relation"
                                @change="val => editedItem.relation = val"
                              />
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col sm="9">
                          <v-row>
                            <v-col>
                              <v-select
                                v-model="editedItem.status"
                                :items="['active','disable']"
                                label="Status"
                              />
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="editedItem.type"
                                :items="['offer','certificate']"
                                label="Type"
                              />
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedItem.product_id"
                                type="number"
                                label="ID группы"
                              />
                            </v-col>
                            <v-col>
                              <v-checkbox
                                v-model.lazy="editedParams['main_offer_in_group']"
                                :label="geParamsName('main_offer_in_group')"
                                false-value="0"
                                true-value="1"
                              />
                            </v-col>
                          </v-row>
                          <v-text-field
                            v-model="editedItem.name"
                            label="Название"
                          />
                          <v-textarea
                            v-model="editedItem.description"
                            label="Описание"
                          />
                          <v-text-field
                            v-model.number="editedItem.price"
                            type="number"
                            label="Цена"
                          />
                          <v-text-field
                            v-model.number="editedItem.oldprice"
                            type="number"
                            label="Старая цена"
                          />
                          <span class="subheading">% скидки</span>
                          <v-chip-group
                            v-model="selectedDiscount"
                            active-class="deep-purple--text text--accent-4"
                            column
                          >
                            <v-chip
                              v-for="discount in offerDiscountValues"
                              :key="discount"
                              :value="discount"
                            >
                              {{ discount }}%
                            </v-chip>
                          </v-chip-group>
                          <file-input :value="editedItem.images" bucket="offers" @change="setImage" />
                          <v-row>
                            <v-col>
                              <v-text-field
                                v-model="video"
                                label="Ссылка на YouTube"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-select
                                v-model="editedParams['brand']"
                                :items="getBrandsList()"
                                label="Бренд"
                              />
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <span class="text-subtitle-1">Для страницы Бренды</span>
                          </v-row>
                          <v-row>
                            <v-col cols="3">
                              <v-checkbox
                                v-model.lazy="editedParams['brand_new_arrivals']"
                                :label="geParamsName('brand_new_arrivals')"
                                false-value="0"
                                true-value="1"
                              />
                            </v-col>
                            <v-col cols="4">
                              <v-checkbox
                                v-model.lazy="editedParams['brand_client_choice']"
                                :label="geParamsName('brand_client_choice')"
                                false-value="0"
                                true-value="1"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-checkbox
                                v-model.lazy="editedParams['inindex']"
                                :label="geParamsName('inindex')"
                                false-value="0"
                                true-value="1"
                              />
                            </v-col>
                            <v-col>
                              <v-checkbox
                                v-model.lazy="editedParams['best']"
                                :label="geParamsName('best')"
                                false-value="0"
                                true-value="1"
                              />
                            </v-col>
                            <v-col>
                              <v-checkbox
                                v-model.lazy="editedParams['celebrity_choice']"
                                :label="geParamsName('celebrity_choice')"
                                false-value="0"
                                true-value="1"
                              />
                            </v-col>
                            <v-col>
                              <v-checkbox
                                v-model.lazy="editedParams['new']"
                                :label="geParamsName('new')"
                                false-value="0"
                                true-value="1"
                              />
                            </v-col>
                            <v-col>
                              <v-checkbox
                                v-model.lazy="editedParams['free_shipping']"
                                :label="geParamsName('free_shipping')"
                                false-value="0"
                                true-value="1"
                              />
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['art']"
                                :label="geParamsName('art')"
                              />
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['diameter']"
                                :label="geParamsName('diameter')"
                              />
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['vis_diameter']"
                                :label="geParamsName('vis_diameter')"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['ringsize']"
                                :label="geParamsName('ringsize')"
                              />
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['_length']"
                                :label="geParamsName('length')"
                              />
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['nlength']"
                                :label="geParamsName('nlength')"
                              />
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['quality']"
                                :label="geParamsName('quality')"
                              />
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['quantitypearls']"
                                :label="geParamsName('quantitypearls')"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['material']"
                                :label="geParamsName('material')"
                              />
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['mechanizm']"
                                :label="geParamsName('mechanizm')"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['atelier']"
                                :label="geParamsName('atelier')"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-checkbox
                                v-model.lazy="editedParams['sale']"
                                :label="geParamsName('sale')"
                                false-value="0"
                                true-value="1"
                              />
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['blength']"
                                :label="geParamsName('blength')"
                              />
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="editedParams['metal']"
                                :items="getParamsValue('metal')"
                                :hint="geParamsName('metal')"
                                persistent-hint
                                single-line
                              />
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="editedParams['color']"
                                :items="getParamsValue('color')"
                                :label="geParamsName('color')"
                                :hint="geParamsName('color')"
                                persistent-hint
                                single-line
                              />
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="editedParams['double_color']"
                                :items="getParamsValue('double_color')"
                                :label="geParamsName('double_color')"
                                :hint="geParamsName('double_color')"
                                persistent-hint
                                single-line
                              />
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="editedParams['age']"
                                :items="getParamsValue('age')"
                                :label="geParamsName('age')"
                                :hint="geParamsName('age')"
                                persistent-hint
                                single-line
                                multiple
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-select
                                v-model="editedParams['clothing']"
                                :items="getParamsValue('clothing')"
                                :label="geParamsName('clothing')"
                                :hint="geParamsName('clothing')"
                                persistent-hint
                                single-line
                                multiple
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-select
                                v-model="editedParams['event']"
                                :items="getParamsValue('event')"
                                :label="geParamsName('event')"
                                :hint="geParamsName('event')"
                                persistent-hint
                                single-line
                                multiple
                              />
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="editedParams['style']"
                                :items="getParamsValue('style')"
                                :label="geParamsName('style')"
                                :hint="geParamsName('style')"
                                persistent-hint
                                single-line
                                multiple
                              />
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="editedParams['pearltype']"
                                :items="getParamsValue('pearltype')"
                                :label="geParamsName('pearltype')"
                                :hint="geParamsName('pearltype')"
                                persistent-hint
                                single-line
                                multiple
                              />
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="editedParams['pearlform']"
                                :items="getParamsValue('pearlform')"
                                :label="geParamsName('pearlform')"
                                :hint="geParamsName('pearlform')"
                                persistent-hint
                                single-line
                                multiple
                              />
                            </v-col>
                            <v-col>
                              <v-checkbox
                                v-model.lazy="editedParams['vibor_glanca']"
                                :label="geParamsName('vibor_glanca')"
                                false-value="0"
                                true-value="1"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-select
                                v-model="editedParams['skin']"
                                :items="getParamsValue('skin')"
                                :label="geParamsName('skin')"
                                :hint="geParamsName('skin')"
                                persistent-hint
                                single-line
                                multiple
                              />
                            </v-col>
                            <v-col>
                              <v-text-field
                                v-model="editedParams['lock']"
                                :label="geParamsName('lock')"
                              />
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn color="blue darken-1" text @click="close">
                        Cancel
                      </v-btn>
                      <v-btn color="green darken-1" @click="save">
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template #item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template #item.position="{ item }">
              <v-edit-dialog
                large
                persistent
                save-text="save"
                @save="set_position(item)"
                @open="setposition = item.positionarr[position_category]"
              >
                {{ item.positionarr[position_category] }}
                <template #input>
                  <v-text-field
                    v-model="setposition"
                    type="number"
                    label="Позиция в категории"
                    single-line
                  />
                </template>
              </v-edit-dialog>
            </template>
            <template #item.image="{ item }">
              <v-img
                width="100px"
                height="100px"
                :src="`${getImage(item)}`"
              />
            </template>
          </v-data-table>
        </material-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snack"
      :timeout="3000"
      color="error"
      top
    >
      {{ snackText }}

      <template #action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  createOffer,
  deleteOffers,
  Offers,
  updateOffer,
  getParamsRangeValueTable,
  getParams,
  setOfferPosition
} from '@/graphql/offers'
// import { Categores } from '@/graphql/category'
import productMixin from '@/helpers/product'
import CategorySelectMain from '@/components/offers/category-select-main'
import CategorySelect from '@/components/offers/category-select'
import CategorySelectFilter from '@/components/offers/category-select-filter'
import Relations from '@/components/offers/relations'
import { getBrands } from '@/graphql/brands'
import FileInput from '~/components/offers/FileInput'

export default {
  components: {
    CategorySelectMain,
    CategorySelect,
    CategorySelectFilter,
    FileInput,
    Relations
  },
  mixins: [productMixin],
  layout: 'dashboard',
  data () {
    return {
      snack: false,
      snackText: '',
      RangeValue: [],
      Params: [],
      video: '',
      headers: [
        {
          sortable: true,
          text: 'Id',
          value: 'id'
        },
        {
          sortable: false,
          text: 'Поз',
          value: 'position'
        },
        {
          sortable: true,
          text: 'Image',
          value: 'image'
        },
        {
          sortable: true,
          text: 'Name',
          value: 'name'
        },
        {
          sortable: true,
          text: 'Price',
          value: 'price'
        },
        {
          sortable: true,
          text: 'OldPrice',
          value: 'oldprice'
        },
        {
          sortable: true,
          text: 'status',
          value: 'status'
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false
        }
      ],
      data: [],
      options: { multiSort: true },
      totalDesserts: 0,
      loading: false,
      editedItem: {},
      dialog: false,
      selected: [],
      searchCategory: '',
      open: [],
      newItem: true,
      search: '',
      searchid: '',
      searchart: '',
      searchstatus: '',
      searchparams: '',
      searchcategory: [],
      position_category: 0,
      setposition: 0,
      editedParams: [],
      brand: '',
      brands: [],
      brandsTotalCount: 0
    }
  },
  apollo: {
    Params: {
      query: getParams,
      result ({
                data,
                loading
              }) {
        if (data.getParams !== undefined && data?.getParams?.params) {
          this.Params = data.getParams.params
        }
      },
      update: data => data.getParams
    },
    getBrands: {
      query: getBrands,
      variables () {
        return {}
      },
      update (data) {
        return data.getBrands.data
      },
      result ({ data }) {
        this.brandsTotalCount = data.getBrands.count
        this.brands = data?.getBrands?.data
      },
      skip () {
        return !this.dialog
      }
    },
    ParamsRangeValue: {
      query: getParamsRangeValueTable,
      result ({ data }) {
        if (data !== undefined && data?.getParamsRangeValueTable) {
          this.RangeValue = data.getParamsRangeValueTable.params_range_values
        }
      },
      update: data => data.getParamsRangeValue
    },
    Offers: {
      query: Offers,
      result ({
                data,
                loading
              }) {
        if (data.offers.offers !== null) {
          this.data = data.offers.offers.map((i) => {
            const pos = []
            if (i?.position) {
              i.position.forEach((p) => {
                pos[p.name] = p.position
              })
            }
            i.positionarr = pos
            return i
          })
          this.totalDesserts = data.offers.count
        }
        this.loading = false
      },
      variables () {
        const sort = []
        for (const key in this.options.sortBy) {
          sort.push({
            name: this.options.sortBy[key],
            desc: this.options.sortDesc[key]
          })
        }
        const search = []
        if (this.search.length > 0) {
          search.push({
            name: 'name',
            value: this.search
          })
        }
        if (this.searchid.length > 0) {
          search.push({
            name: 'id.like',
            value: this.searchid
          })
        }
        if (this.searchart.length > 0) {
          search.push({
            name: 'params.art.like',
            value: this.searchart
          })
        }
        if (this.searchstatus.length > 0) {
          search.push({
            name: 'status',
            value: this.searchstatus
          })
        }
        if (this.searchcategory.length > 0) {
          this.searchcategory.forEach(item => search.push({
            name: 'category_slug',
            value: item
          }))
        }
        return {
          sort,
          search,
          limit: this.options.itemsPerPage,
          offset: this.options.itemsPerPage * (this.options.page - 1)
        }
      },
      update: data => data.Offers
    }
  },
  computed: {
    filter () {
      // на случай точного поиска
      return false
      // ? (item, search, textKey) => item[textKey].includes(search)
      // : undefined
    },
    offerDiscountValues () {
      const discounts = []
      for (let i = 5; i <= 85; i += 5) {
        discounts.push(i)
      }
      return discounts
    },
    selectedDiscount: {
      get () {
        return parseInt(this?.editedItem?.params?.find(param => param.slug === 'discount')?.value) ?? ''
      },
      set (value) {
        if (!value) {
          if (this.editedItem.oldprice) {
            this.editedItem.price = this.editedItem.oldprice
            this.editedItem.oldprice = 0
          }
          return
        }
        this.editedParams.discount = value.toString()
        if (this.editedItem.oldprice) {
          this.editedItem.price = this.calculateProductDiscount(this.editedItem.oldprice, value)
        } else {
          this.editedItem.oldprice = this.editedItem.price
          this.editedItem.price = this.calculateProductDiscount(this.editedItem.oldprice, value)
        }
      }
    }
  },
  watch: {
    options (val) {
      this.loading = true
      this.$apollo.queries.Offers.refetch()
    },
    dialog (val) {
      if (val) {
        if (this.newItem) {
          this.editedItem = Object.assign({})
        }
      } else {
        this.newItem = true
      }
    }
  },
  methods: {
    setEditParams (params) {
      this.editedParams = []
      params?.forEach((item) => {
        if (item.slug === 'clothing' || item.slug === 'age' || item.slug === 'event' || item.slug === 'pearltype' || item.slug === 'pearlform' || item.slug === 'style' || item.slug === 'skin') {
          this.editedParams[item.slug] = item.value.split(',').map(i => i.trim())
        } else if (item.slug === 'length') {
          this.editedParams._length = item.value
        } else {
          this.editedParams[item.slug] = item.value
        }
      })
      if (this.Params?.length > 0) {
        this.Params.forEach((param) => {
          let name = param.slug
          if (param.slug === 'length') {
            name = '_length'
          }
          if (this.editedParams[name] === undefined) {
            this.editedParams[name] = ''
          }
        })
      }
    },
    getBrandsList () {
      return [{ value: '', text: '-' }, ...this?.brands?.map(item => ({ value: item?.id.toString(), text: item?.name })) ?? []]
    },
    getVideo (extra) {
      extra?.forEach((item) => {
        if (item.name === 'video') {
          this.video = item.value
        }
      })
    },
    selectFilterCategory (val) {
      this.searchcategory = val.map(i => i.slug)
      this.position_category = val.map(i => i.id)?.[0] || 0
      this.$apollo.queries.Offers.refetch()
    },
    set_position (val) {
      if (!val?.position) {
        val.position = []
      }
      val.position[this.position_category] = this.setposition

      this.$apollo
          .mutate({
            mutation: setOfferPosition,
            variables: {
              id: val.id,
              category_id: Number(this.position_category),
              position: Number(this.setposition)
            }
          })
          .then((data) => {
            this.$apollo.queries.Offers.refetch()
          })
          .catch((error) => {
            console.error(error)
          })
    },
    geParamsName (param_slug) {
      const name = this?.Params && this?.Params.length > 0 && this?.Params?.filter(item => item.slug === param_slug)?.[0]?.name
      return name !== undefined ? name : param_slug
    },
    getParamsValue (param_slug) {
      const arr = []
      this?.RangeValue?.filter(item => item.params_slug === param_slug).forEach((item) => {
        arr.push({
          value: item.slug,
          text: item.value
        })
      })

      return arr
    },
    setImage (images) {
      this.editedItem.images = images
    },
    getImage (item) {
      if (item.images != null && item.images.length > 0) {
        return item.images[0].file?.url
      } else {
        return ''
      }
    },
    getImage2 (item) {
      return item?.file?.url
    },
    deleteOffers () {
      if (confirm('Уверены что хотите удалить товар ?')) {
        const ids = []
        this.selected.forEach(item => ids.push(item.id))
        this.$apollo
            .mutate({
              mutation: deleteOffers,
              variables: {
                ids
              }
            })
            .then((data) => {
              this.$apollo.queries.Offers.refetch()
            })
            .catch((error) => {
              console.error(error)
            })
      }
    },
    editItem (item) {
      this.newItem = false
      item = this.formatTagsForInput(item)
      item = this.excludeTagsFromCategories(item)
      this.editedItem = Object.assign({}, item)
      this.setEditParams(item?.params)
      this.getVideo(item?.extras)
      this.dialog = true
    },
    close () {
      this.newItem = true
      this.editedItem = Object.assign({})
      this.editedItem.images = []
      this.editedItem.relation = []
      this.editedParams = []
      this.setEditParams([])
      this.dialog = false
    },
    addCategory (cats) {
      this.editedItem.category = cats.map(i => i.id)
    },
    addTags (tags) {
      this.editedItem.tags = tags.map(i => i.id)
    },
    addCategoryId (id) {
      this.editedItem.category_id = id
    },
    excludeTagsFromCategories (item) {
      if (item?.category && item?.category.length > 0 && item?.tags && item?.tags.length > 0) {
        item.category = item.category.filter(c => !item.tags.find(t => t === c))
      }
      return item
    },
    formatTagsForInput (item) {
      if (item?.tags && item?.tags.length > 0) {
        item.tags = item.tags.map(t => t.id ?? t)
      }
      return item
    },
    save (n) {
      // need to clone this.editedItem to prevent it future editing
      const inputOffer = Object.assign({}, this.editedItem)
      const images = []
      if (this?.editedItem?.images && this?.editedItem?.images.length > 0) {
        this?.editedItem?.images.forEach((item) => {
          images.push(Object.assign({}, item))
        })
      }
      inputOffer.images = images
      inputOffer.category = inputOffer?.category?.filter(x => !!x)
      delete inputOffer.__typename
      inputOffer?.images?.forEach((item) => {
        item.key = item?.file?.key
        delete item.file
        delete item.__typename
      })
      if (inputOffer.oldprice === '') {
        inputOffer.oldprice = 0
      }
      const params = []
      for (const name in this.editedParams) {
        const param = this?.Params?.map(i => i.slug === name)?.[0]
        let n = name
        if (name === '_length') {
          n = 'length'
        }
        let v = this.editedParams[name]
        if (Array.isArray(this.editedParams[name])) {
          v = this.editedParams[name].filter(v => v.toString().length > 0).join(',')
        }
        if (n === 'brand' && !v.toString().length) {
          continue
        }
        params.push({
          slug: n,
          value: v.toString(),
          visible: param?.visible || 0
        })
      }

      inputOffer.params = params
      inputOffer?.position?.forEach((item) => {
        delete item.__typename
      })
      delete inputOffer.positionarr
      inputOffer.extras = [{
        name: 'video',
        value: this.video
      }]
      if (this.newItem) {
        // добавление
        delete this.editedItem.id
        this.$apollo
            .mutate({
              mutation: createOffer,
              variables: {
                input: inputOffer
              }
            })
            .then((data) => {
              this.$apollo.queries.Offers.refetch()
            })
            .catch((error) => {
              this.snack = true
              this.snackText = error
            })
      } else {
        // редактирование
        this.$apollo
            .mutate({
              mutation: updateOffer,
              variables: {
                input: inputOffer
              }
            })
            .then((data) => {
              this.$apollo.queries.Offers.refetch()
            })
            .catch((error) => {
              this.snack = true
              this.snackText = error
            })
      }

      this.close()
    }
  }
}
</script>

<style></style>
